import React from 'react';
import styled from 'styled-components';
import {useLivenessStore, useProgressStore} from './store';

const ProgressBarContainer = styled.div`
  width: 100%;
  height: 8px;
  background-color: #e0e0e0;
  overflow: hidden;
  position: absolute;
  bottom: 0;
  z-index: 2;
`;

const ProgressBarFill = styled.div<{$progress: number}>`
  height: 100%;
  background-color: #32d7be;
  width: ${({$progress}) => `${$progress}%`};
  transition: width 0.2s ease-out;
`;

type Props = {
  className?: string;
};
export const ChallengeProgressBar: React.FC = ({className}: Props) => {
  const progress = useProgressStore(state => state.progress);
  const currentStep = useLivenessStore(state => state.currentStep);
  const stepStatus = useLivenessStore(state => state.stepStatus);

  const isVisible =
    stepStatus === 'progress' &&
    currentStep !== 'LOOK_STRAIGHT' &&
    currentStep !== 'COMPLETED' &&
    currentStep !== 'BLINK' &&
    progress != null;

  if (!isVisible) {
    return null;
  }

  return (
    <ProgressBarContainer className={className}>
      <ProgressBarFill $progress={progress} />
    </ProgressBarContainer>
  );
};
